import Tdg_TourItemModelBase from '../_generated/modelBases/tdg-tour-item-model-base';

export default class Tdg_TourItemModel extends Tdg_TourItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
